<template>
    <div class="empty-state">
        <NewIllustration
            v-if="image"
            class="image"
            data-qa="image"
            :name="image"
        />

        <slot name="title" />

        <h3 v-if="title && !$slots.title" data-qa="title">
            {{ title }}
        </h3>

        <p v-if="description" data-qa="description">
            {{ description }}
        </p>

        <div v-if="$slots.default" class="slot">
            <slot />
        </div>
    </div>
</template>

<script>
import NewIllustration from '@/components/funnel/ds-core-dupes/NewIllustration/NewIllustration.vue';

export default {
    components: {
        NewIllustration
    },
    props: {
        title: String,
        description: String,
        image: String,
    }
};
</script>

<style lang="scss" scoped>
    .empty-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    .image {
        margin-bottom: $spacing-300;
    }

    h3 {
        font-family: $font-family-secondary-title;
        font-weight: $font-weight-bold;
        max-width: 31.25rem;
    }

    p {
        color: $color-gray-800;
        margin: $spacing-200 0 0;
        max-width: 31.25rem;
    }

    .slot {
        margin-top: $spacing-300;
    }
</style>
